export const environment = {
  production: true,
  // apiURL: 'https://dc6grv37fh.execute-api.us-west-1.amazonaws.com/dev/microsite/',
  // apiURL: "https://n6quw9lg9l.execute-api.us-east-1.amazonaws.com/prod/microsite/",  
  apiURL:"https://papapi.dev.dctinc.net/microsite/",
  brandId: 1
};